// @flow

import React, { Component } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";
import ResponsiveImage from "../ResponsiveImage";
import AccordionFound from "../AccordionFound";
import TechnicalCard from "../TechnicalCard";
import "./AgainstWater.scss";

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false,
    };
  }

  toggleMenu() {
    this.setState({
      menu: !this.state.menu,
    });
  }

  closeMenu() {
    this.setState({
      menu: false,
    });
  }

  scrollWithOffset = (el, offset, activeSection) => {
    const elementPosition = el.offsetTop - offset;
    console.log("Smooth scroll ", elementPosition);
    if (typeof window !== "undefined") {
      window.scroll({
        top: elementPosition,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  getClosestParent(element, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        ((s) => {
          var matches = (this.document || this.ownerDocument).querySelectorAll(
              s
            ),
            i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
        });
    }

    // Get the closest matching element
    for (; element && element !== document; element = element.parentNode) {
      if (element.matches(selector)) return element;
    }
    return null;
  }

  handleClick = (event, accNumber) => {
    console.log(event.target);
    let parent = this.getClosestParent(event.target, ".accordion__item");
    let activeItems = document.querySelectorAll(
      `.active-acc__item${accNumber}`
    );
    activeItems.forEach((item) =>
      item.classList.remove(`active-acc__item${accNumber}`)
    );
    parent.classList.add(`active-acc__item${accNumber}`);
  };

  showAccordion = (e, accId) => {
    if (window.location.pathname == "/fundamenty") {
      e.preventDefault();
    }
    let element = document.querySelector(`#${accId}`);
    element.classList.add("active");
  };

  showDoubleAccordion = (e, showId, accordionId) => {
    if (window.location.pathname == "/fundamenty") {
      e.preventDefault();
    }
    let showElement = document.querySelector(`#${showId}`);
    showElement.classList.add("active");

    let containers = document.querySelectorAll(".double-acc__container");
    containers.forEach((item) => item.classList.remove("active"));
    let accID = document.querySelector(`#${accordionId}`);
    accID.classList.add("active");
  };

  hideAccordion = (accId, accNumber) => {
    let element = document.querySelector(`#${accId}`);
    element.classList.remove("active");
  };

  render() {
    return (
      <React.Fragment>
        <section id="foundation2" className="hydroisolation-against-water">
          <div className="hydroisolation-against-water_container container row">
            <div id="hydroisolation-section-2" className="col-12">
              <img src="/img/evomer-logo-grey.png" className="logo-grey" />
              <p className="h3-red bold-header">Szybka przeciwwodna</p>
              <p className="h4-black small-bold-header">
                Hydroizolacja fundamentów
              </p>
              <p className="text-basic-usage">
                Stosowana dla budynków podpiwniczonch lub posadowionych poniżej
                3 M P.P.T. posadowionych na gruntach słabo przepuszczalnych oraz
                z zagrożeniem stałym lub czasowym podwyższeniem poziomu wód
                gruntowych.
              </p>
            </div>
          </div>
        </section>

        <section className="hydroisolation-against-water-photos">
          <div className="hydroisolation-photos_container container row">
            <div className="col-8 col-ml-12 photo">
              {/*  <img src="/img/photo6.jpg" className="picture"/> */}
              <ResponsiveImage imageName="photo6.jpg" imageClass={"picture"} />
            </div>
            <div className="col-4 col-ml-12 photo-description">
              <div className="description-background">
                <p className="description-title">
                  <span className="big-letter">P</span>rzygotowanie podłoża
                </p>
                <p className="text-basic">
                  Przed wykonaniem prac hydroizolacyjnych przygotuj odpowiednio
                  podłoże – oczyść powierzchnię z zanieczyszczeń i pyłu -
                  powierzchnia powinna być odtłuszczona, pozbawiona krawędzi,
                  narostów i nierówności. Narożniki zewnętrzne należy wyoblić,
                  fugi pomiędzy bloczkami fundamentowymi zaszpachlować zaprawą
                  cementową na gładko, raki w ścianach wylewanych zaszpachlować.
                </p>
              </div>
            </div>
          </div>

          <div className="advice_container container row">
            <div className="advice-background">
              <p className="advice-title">Rada fachowca</p>
              <p className="advice-text text-basic">
                Powinniśmy pamiętać, że gruntu Evomer nie można nanosić na
                podłoża zmrożone lub oszronione. Bezwzględnie należy też usunąć
                spękane, luźno związane elementy podłoża oraz naloty roślinne
                (mchy, porosty).
              </p>
            </div>
          </div>

          <div className="priming_container container row row-reverse">
            <div className="col-4  col-ml-12 photo-description">
              <div className="description-background">
                <p className="description-title">
                  <span className="big-letter">G</span>runtowanie
                </p>
                <p className="text-basic">
                  Zagruntuj powierzchnię za pomocą Szybkiego Gruntu Evomer
                  używając pędzla , wałka lub natryskowo. Orientacyjne zużycie
                  emulsji to 0,15 kg/m2.
                </p>
                <img src="/img/gruntowanie.png" className="product-photo" />

                <NavLink
                  smooth
                  scroll={(el) => {
                    this.scrollWithOffset(el, 100, "acc6");
                  }}
                  onClick={(e) => this.showAccordion(e, "acc6")}
                  className="button-product-info"
                  to={"/#acc6"}
                >
                  <span className="text-basic">Informacja o produkcie</span>
                </NavLink>
              </div>
            </div>
            <div id="acc6" className="col-8 col-ml-12 photo accordion-col">
              <ResponsiveImage imageName="photo7.jpg" imageClass={"picture"} />
              <div className="accordion-container">
                <div>
                  <h2 className="accordion-title">SZYBKI GRUNT EVOMER</h2>
                  <AccordionFound product="fastGround"></AccordionFound>
                  <button
                    onClick={() => this.hideAccordion("acc6", "7")}
                    className="close-btn"
                  >
                    <span className="af-icon-cross"></span>
                  </button>
                </div>
                <TechnicalCard
                  pdf={
                    "/pdf/evomer-szybki-grunt-01-TDS-Karta-techniczna-produktu.pdf"
                  }
                />
              </div>
            </div>
          </div>

          <div className="hydroproofing-mass_container container row ">
            <div id="acc7" className="col-8 col-ml-12 photo accordion-col">
              <ResponsiveImage imageName="photo8.jpg" imageClass={"picture"} />
              <div className="accordion-container">
                <div>
                  <h2 className="accordion-title">ABIZOL W 2K</h2>
                  <AccordionFound product="abizolw2k"></AccordionFound>
                  <button
                    onClick={() => this.hideAccordion("acc7", "7")}
                    className="close-btn"
                  >
                    <span className="af-icon-cross"></span>
                  </button>
                </div>
                <TechnicalCard
                  pdf={
                    "/pdf/abizol-w-2k-masa-bitumiczno-polimerowa-Karta-techniczna-produktu.pdf"
                  }
                />
              </div>
            </div>
            <div className="col-4 col-ml-12  photo-description">
              <div className="description-background">
                <p className="description-title">
                  <span className="big-letter">P</span>rzygotowanie masy
                  hydroizolacyjnej
                </p>
                <p className="text-basic">
                  Po wyschnięciu gruntu (zazwyczaj ok. 20 - 30 min - w
                  zależności od warunków pogodowych) przygotuj masę Abizol W2k:
                  wyjmij składnik B z wiadra, wymieszaj płynny składnik
                  mieszadłem wolnoobrotowym. Dodawaj składnik sypki do masy
                  bitumicznej ciągle mieszając do uzyskania jednolitej
                  konsystencji.
                </p>
                <img src="/img/abizol.png" className="product-photo" />
                <NavLink
                  smooth
                  scroll={(el) => {
                    this.scrollWithOffset(el, 100, "acc7");
                  }}
                  onClick={(e) => this.showAccordion(e, "acc7")}
                  className="button-product-info"
                  to={"/#acc7"}
                >
                  <span className="text-basic">Informacja o produkcie</span>
                </NavLink>
              </div>
            </div>
          </div>

          <div className="shells_container container row row-reverse">
            <div className="col-4 col-ml-12 photo-description">
              <div className="description-background">
                <p className="description-title">
                  <span className="big-letter">P</span>owłoki hydoroizolacyjne
                </p>
                <p className="text-basic">
                  Po dokładnym wymieszaniu obu składników odczekaj 5 min i
                  nakładaj masę przy pomocy pacy. Nie czekając na wyschnięcie
                  powłoki wykonaj fasetę na połączeniu ściany i ławy
                  fundamentowej przy pomocy odpowiedniej kielni. Po wyschnięciu
                  pierwszej warstwy Abizolu W2k i fasety (ok. 4-5 godz.) nałóż
                  drugą warstwę produktu.
                </p>
                <img src="/img/abizol.png" className="product-photo" />
                <NavLink
                  smooth
                  scroll={(el) => {
                    this.scrollWithOffset(el, 100, "acc8");
                  }}
                  onClick={(e) => this.showAccordion(e, "acc8")}
                  className="button-product-info"
                  to={"/#acc8"}
                >
                  <span className="text-basic">Informacja o produkcie</span>
                </NavLink>
              </div>
            </div>
            <div id="acc8" className="col-8 col-ml-12 photo accordion-col">
              <ResponsiveImage imageName="photo9.jpg" imageClass={"picture"} />
              <div className="accordion-container">
                <div>
                  <h2 className="accordion-title">ABIZOL W 2K</h2>
                  <AccordionFound product="fastGround"></AccordionFound>
                  <button
                    onClick={() => this.hideAccordion("acc8", "7")}
                    className="close-btn"
                  >
                    <span className="af-icon-cross"></span>
                  </button>
                </div>
                <TechnicalCard
                  pdf={
                    "/pdf/abizol-w-2k-masa-bitumiczno-polimerowa-Karta-techniczna-produktu.pdf"
                  }
                />
              </div>
            </div>
          </div>

          <div className="advice_container container row">
            <div className="advice-background">
              <p className="advice-title">Rada fachowca</p>
              <p className="advice-text text-basic">
                Kolejne warstwy powłoki powinniśmy nakładać prostopadle do
                poprzedniej (tzw. metodą krzyżową), co pozwoli na
                wyeliminowavnie ewentualnych nieciągłości.
              </p>
            </div>
          </div>

          <div className="thermal-insulation_container container row">
            <div id="acc9" className="col-8 col-ml-12 photo accordion-col ">
              <ResponsiveImage imageName="photo10.jpg" imageClass={"picture"} />
              <div id="acc9-1" className="double-acc__container">
                <div>
                  <h2 className="accordion-title">Abizol ST</h2>
                  <AccordionFound product="abizolST"></AccordionFound>
                  <button
                    onClick={() => this.hideAccordion("acc9", "7")}
                    className="close-btn"
                  >
                    <span className="af-icon-cross"></span>
                  </button>
                </div>
                <TechnicalCard
                  pdf={
                    "/pdf/abizol-st-lepik-do-styropianu-Karta-techniczna-produktu.pdf"
                  }
                />
              </div>
              <div id="acc9-2" className="double-acc__container">
                <div>
                  <h2 className="accordion-title">XPS</h2>
                  <AccordionFound product="xps"></AccordionFound>
                  <button
                    onClick={() => this.hideAccordion("acc9", "7")}
                    className="close-btn"
                  >
                    <span className="af-icon-cross"></span>
                  </button>
                </div>
                <TechnicalCard
                  pdf={
                    "/pdf/eos-klej-do-plyt-xps-Karta-techniczna-produktu.pdf"
                  }
                />
              </div>
            </div>
            <div className="col-4 col-ml-12 photo-description">
              <div className="description-background">
                <p className="description-title">
                  <span className="big-letter">M</span>ontaż termoizolacji
                </p>
                <p className="text-basic">
                  Po wyschnięciu drugiej warstwy można przyklejać izolacje
                  termiczną np. przy pomocy szybkiego pianokleju Tytan
                  Professional XPS lub tradycyjnie Abizolem ST.
                </p>
                <div className="products-container">
                  <div className="col-6 col-s-12 product">
                    <img src="/img/AbizolST.png" className="product-photo" />
                    <NavLink
                      smooth
                      scroll={(el) => {
                        this.scrollWithOffset(el, 100, "acc9");
                      }}
                      onClick={(e) =>
                        this.showDoubleAccordion(e, "acc9", "acc9-1")
                      }
                      className="button-product-info"
                      to={"/#acc9"}
                    >
                      <span className="text-basic">Informacja o produkcie</span>
                    </NavLink>
                  </div>
                  <div className="col-6  col-s-12 product">
                    <img src="/img/klej.png" className="product-photo-glue" />
                    <NavLink
                      smooth
                      scroll={(el) => {
                        this.scrollWithOffset(el, 100, "acc9");
                      }}
                      onClick={(e) =>
                        this.showDoubleAccordion(e, "acc9", "acc9-2")
                      }
                      className="button-product-info"
                      to={"/#acc9"}
                    >
                      <span className="text-basic">Informacja o produkcie</span>
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AgainstWater/AgainstWater.js